class LiveChat extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.live-chat__button');
    console.log('LiveChat initialized', this.button);

    // Add click event listener to the button
    if (this.button) {
      this.button.addEventListener('click', () => {
        this.waitForPodiumWidget();
      });
    }
  }

  /**
   * Waits for the Podium widget to be added to the DOM.
   * Opens the chat once the widget is detected.
   */
  waitForPodiumWidget() {
    const widgetId = 'podium-website-widget';

    // Check if the widget is already in the DOM
    if (document.getElementById('podium-website-widget')) {
      PodiumWebChat.open();
      return;
    }

    // Use MutationObserver to watch for the widget's appearance
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          const widget = document.getElementById('podium-website-widget');
          if (widget) {
            PodiumWebChat.open();
            observer.disconnect();
            break;
          }
        }
      }
    });

    // Observe the document's body for added child nodes
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

customElements.define('live-chat', LiveChat);
